// extracted by mini-css-extract-plugin
export default {"youtubeCard":"YoutubeSourceCard_youtubeCard__Qc-P8"};